import React, { Component } from "react";
import {

  Slider,
  Sidebar,
  Footers,
  Home,
} from "components";
import { Container, Col, Row } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import { setProd } from "../../actions/cart_Action";

import { connect } from "react-redux";

class MainApp extends Component {
  constructor(props) {
    // Inherit constructor
    super(props);
    // Bind functions
    this.loadUser = this.loadUser.bind(this);
    // Call `loadUser` before mounting the app
    this.loadUser();
  }

  // Get latest user object from blockchain
  loadUser() {
    // Extract `setUser` of `UserAction` and `user.name` of UserReducer from redux
    const { setProd } = this.props;
    // Send request the blockchain by calling the ApiService,
    // Get the user object and store the `win_count`, `lost_count` and `game_data` object
    return ApiService.getUserByName().then(items => {
      items.map(itemr => {
        setProd(itemr);
        // console.log(itemr)

        //console.log(inititem)
        return console.log();
      });
    });
  }

  render() {
    // Extract data from user data of `UserReducer` from redux
    //const name = localStorage.getItem("cardgame_account");


    return (
      <div>
        {/* {!name &&
      <NavigationBar/>}
      {name &&
      <NavigationBar2/>} */}
        {/* {console.log("john rule", name)}
  */}

  <div className="container-fluid">
          <Row>
            
            <Col sm={3}>
              <Sidebar />
            </Col>

            <Col sm={9}>
              <Slider />{" "}
              {/* <SliderList/> <use slider list here instead of slider if you want to import data from jason>*/}
              <Home />
            </Col>
          </Row>
       </div>

        <Footers />
      </div>
    );
  }
}

// Map all state to component props (for redux to connect)
const mapStateToProps = state => state;

// Map the following action to props
const mapDispatchToProps = {
  setProd: setProd
};

// Export a redux connected component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainApp);
